export const IS_MOBILE_SIZE = '(max-width: 900px)';
export const IS_TABLET_SIZE = '(max-width: 1200px)';
